export default __webpack_public_path__ + "static/media/mailchimp.f43a3051.svg";